import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import SparePartItem from './SparePartItem.vue';
import { store } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SparePartList',
  props: {
    sparePartCategories: null
  },
  setup(__props: any) {

const props = __props as { sparePartCategories?: SparePartVariantCategoryViewObject[] }


const textColor = computed<OpacityFunction>(() => store.getters['app/textColor']);

const showAll = ref<boolean>(false);

const limit = 3;

const allSpareParts = computed<SparePartVariantBaseViewObject[]>(() => {
    return props.sparePartCategories.flatMap(category => category.sparePartVariants);
});
const hasToggle = computed<boolean>(() => allSpareParts.value.length > limit);
const spareParts = computed<SparePartVariantBaseViewObject[]>(() => {
    return showAll.value ? allSpareParts.value : allSpareParts.value.slice(0, limit);
});

function toggleAll() {
    showAll.value = !showAll.value;
}

return { __sfc: true,props, textColor, showAll, limit, allSpareParts, hasToggle, spareParts, toggleAll, SparePartItem }
}

})